<div class="sam-margin sam-chat-window-close-dialog">
   <div class="title sam-float-left">
      {{ 'samwin.chat_dialog.close_confirmation' | translate }}
   </div>
   <div class="sam-full-width">
      <button kendoButton [primary]="true" (click)="onComplete()" class="sam-margin-right sam-float-left">
         {{ 'samwin.chat_dialog.actions.complete' | translate }}
      </button>
      <button kendoButton (click)="onCancel()" class="sam-float-right">{{ 'common.cancel' | translate }}</button>
   </div>
</div>
